module.exports = __webpack_public_path__ + "static/media/Omar.b6ff2517.jpeg";